<template>
  <div>
    <a-modal :title="type == 1 ? '安装前检测' : '验收单'" width="423px" :visible="visible" :confirm-loading="confirmLoading"
      @ok="handleOk" @cancel="handleCancel" :footer="null">
      <div class="screen">
        <div class="title mb-10">风险告知书</div>
        <p style="color:rgb(255, 112, 112);">
          {{ info.riskInformed }}
        </p>
        <div class="item mb-10" v-for="(item, i) in list" :key="i">
          <div class="title">{{ i + 1 }}、{{ item.title }}</div>
          <div class="flex_l mt-6">
            <div class="mr-20 flex_l">
              <img v-if="item.answer == '否'" src="@/assets/1.png" alt="" />
              <img v-else src="@/assets/2.png" alt="" />
              <span>是</span>
            </div>
            <div class="flex_l">
              <img v-if="item.answer == '是'" src="@/assets/1.png" alt="" />
              <img v-else src="@/assets/2.png" alt="" />
              <span>否</span>
            </div>
          </div>
        </div>
        <div class="title mt-15 mb-10">客户签字</div>
        <img class="sign" :src="type == 1 ? imgUrl + info.signatureUrl : imgUrl + info.acceptanceUrl" alt="" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { imgUrl } from '@/utils/common'
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      type: 1, // type 1 安装前  2 验收单
      info: {},
      list: [],
      imgUrl: imgUrl
    }
  },
  mounted() { },
  methods: {
    // 验收单弹窗  type 1 安装前  2 验收单
    init(type, info) {
      this.visible = true
      this.type = type
      this.info = info
      this.list = type == 1 ? info.resultList : info.acceptanceList
    },
    handleOk(e) {
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.screen {
  width: 375px;
  min-height: 667px;

  .item {
    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
  }

  .title {
    font-weight: 700;
  }

  .sign {
    width: 100%;
    height: 180px;
    border: 1px solid #ccc;
  }
}
</style>
